export enum ButtonType {
  PRIMARY = "primary",
  SECONDARY = "secondary",
  OUTLINE = "outline",
  GHOST = "ghost",
  ATTENTION = "attention",
}

export enum ButtonSize {
  L = "l",
  M = "m",
  S = "s",
}
